import { CircleArrowLeft } from "lucide-react";
import React from "react";
import RolesManagement from "./RolesManagement";

const ManageRoles: React.FC<{ exitManageMode: () => void }> = ({
  exitManageMode,
}) => {
  return (
    <section>
      <section className="mb-4">
        <button
          onClick={exitManageMode}
          className="text-gray-500 flex items-center gap-1"
        >
          <CircleArrowLeft />
          <span>back</span>
        </button>
      </section>
      <section className="bg-white rounded-md flex flex-col gap-4 p-4">
        <RolesManagement />
      </section>
    </section>
  );
};

export default ManageRoles;
